const TEXT_EFFECTS_PRESERVE_KEYS = [ 'line-height', 'letter-spacing' ];
const TEXT_EFFECTS_COMBINE = [ 'Bold', 'Italic' ];
const TEXT_EFFECTS = [
  { name: 'None' },

  // We have an issue here: when we import our fonts, we don't also import a bold version, which forces browsers to
  // synthesize a bold version. Chrome does so without expanding the spacing between letters, however Safari does not,
  // so we just expand the outline to avoid inconsistent cross-browser layouts. Note that any effects have to be aware
  // of how to combine correctly with this pseudo-bold effect.
  { css: { 'text-stroke': '.03em currentColor' }, name: 'Bold' },

  { css: { 'font-style': 'italic' }, name: 'Italic' },
  { css: { 'text-shadow': 'rgba(0, 0, 0, .6) 0 0 .7rem' }, name: 'Shadow' },
  {
    css: {
      'text-stroke': '.011em currentColor',
      'text-fill-color': 'transparent'
    },
    combine: {
      'Bold': { 'text-stroke': '.031em currentColor' }
    },
    name: 'Outline'
  },
  {
    css: {
      'background': 'currentColor',
      'text-shadow': '2px 2px 3px rgba(255,255,255,0.5)',
      'text-fill-color': 'transparent',
      'background-clip': 'text',
      '-webkit-background-clip': 'text'
    },
    name: 'Emboss'
  },
  {
    css: {
      'text-shadow': '0 .015625em 0 #ccc, 0 0.03125em 0 #c9c9c9, 0 0.046875em 0 #bbb, 0 0.0625em 0 #b9b9b9, 0 0.078125em 0 #aaa, 0 0.09375em .015625em rgba(0,0,0,.1), 0 0 0.078125em rgba(0,0,0,.1), 0 .015625em 0.046875em rgba(0,0,0,.3), 0 0.046875em 0.078125em rgba(0,0,0,.2), 0 0.078125em 0.15625em rgba(0,0,0,.25), 0 0.15625em 0.15625em rgba(0,0,0,.2), 0 0.3125em 0.3125em rgba(0,0,0,.15)'
    },
    name: '3D'
  },
  {
    css: {
      'text-shadow': '-.02em -.02em 0 #222, .02em -.02em 0 #222, -.02em .02em 0 #222, .02em .02em 0 #222, .05em .05em 0 currentColor',
      'transform': 'translate(-.035em, -.035em)'
    },
    name: 'Offset'
  },
  {
    css: {
      'background': 'linear-gradient(45deg, #F9F1F7A0, #EBF6F8A0)',
      'background-clip': 'text',
      '-webkit-background-clip': 'text',
      'text-stroke': '.002em currentColor',
      'text-fill-color': 'transparent'
    },
    cssPreview: {
      'background': 'linear-gradient(45deg, #C9C1C7, #BBC6C8)',
    },
    combine: {
      'Bold': { 'text-stroke': '.02em currentColor' }
    },
    name: 'Glass'
  },
  // {
  //   css: {
  //     'text-shadow': '.01em .01em 0 #FFB650, .02em .02em 0 #FFD662, .03em .03em 0 #FF80BF, .04em .04em 0 #EF5097, .05em .05em 0 #6868AC, .06em .06em 0 #90B1E0',
  //     'transform': 'translate(-.03em, -.03em)'
  //   },
  //   name: 'Layers'
  // },
  // {
  //   css: {
  //     'background': 'url("/gold_1.jpeg") repeat',
  //     'background-clip': 'text',
  //     '-webkit-background-clip': 'text',
  //     'text-fill-color': 'transparent',
  //     'text-stroke': '0.01em rgba(0, 0, 0, .05)',
  //     'text-shadow': '0.01em 0.01em 0 #c3a34355'
  //   },
  //   name: 'Gold'
  // },
  // {
  //   css: {
  //     'background': 'url("/silver-2.jpeg") repeat',
  //     'background-clip': 'text',
  //     '-webkit-background-clip': 'text',
  //     'text-fill-color': 'transparent',
  //     'text-stroke': '0.01em rgba(0, 0, 0, .05)',
  //     'text-shadow': '0.01em 0.01em 0 rgba(191, 187, 192, .3)'
  //   },
  //   name: 'Silver'
  // },
  {
    css: {
      'background': 'url("/textures/buried.png"), currentColor',
      'background-clip': 'text',
      '-webkit-background-clip': 'text',
      'text-fill-color': 'transparent',
      'text-shadow': '0 0 0.005em #8881, 0.01em 0.01em 0.005em #0001'
    },
    name: 'Foil'
  },
  {
    css: {
      'background': 'url("/textures/dark-leather.png"), currentColor',
      'background-clip': 'text',
      '-webkit-background-clip': 'text',
      'text-fill-color': 'transparent',
      'text-shadow': '0 0 0.005em #8881, 0.01em 0.01em 0.005em #0001'
    },
    name: 'Dimpled'
  },
  {
    css: {
      'background': 'url("/textures/binding-dark.png"), currentColor',
      'background-clip': 'text',
      '-webkit-background-clip': 'text',
      'text-fill-color': 'transparent',
      'text-stroke': '0.01em #FFF1',
      'text-shadow': '0.01em 0.01em 0 #FFF3'
    },
    combine: {
      'Bold': { 'text-stroke': '.03em currentColor' }
    },
    name: 'Fabric'
  },
  {
    css: {
      'background': 'linear-gradient(15deg, #F000 0%, #F000 35%, #FFFF 49.95%, #FFFF 50.15%, #F000 65%, #F000), linear-gradient(to right, #ef548f, #ef8b6d, #cfef6b, #3bf0c1, #bb4af0)',
      'background-clip': 'text',
      '-webkit-background-clip': 'text',
      'text-fill-color': 'transparent',
      'text-stroke': '0.01em currentColor'
    },
    combine: {
      'Bold': { 'text-stroke': '.03em currentColor' }
    },
    name: 'Rainbow'
  },
  {
    css: {
      'text-fill-color': '#FFF',
      // 'text-shadow': '0 0 0.05em #FFF, 0 0 0.2em #fe05e1, 0 0 0.3em #fe05e1'
      'text-shadow': '0 0 0.05em #FFF, 0 0 0.2em currentColor, 0 0 0.3em currentColor',
      'text-stroke': '0 #FFF'
    },
    combine: {
      'Bold': { 'text-stroke': '.03em #FFF' }
    },
    name: 'Neon'
  },
  {
    css: {
      'background': 'linear-gradient(-90deg, currentColor 40%, #fafafa 50%, currentColor 60%)',
      'background-size': '300%',
      'background-position-x': '0%',
      'background-clip': 'text',
      '-webkit-background-clip': 'text',
      'text-fill-color': 'transparent',
      'animation': '1s linear infinite font-effect-shimmer'
    },
    name: 'Shimmer'
  },
  // {
  //   // Warning: this one appears to be very resource-intensive
  //   css: {
  //     'animation-duration': '0.8s',
  //     'animation-name': 'font-effect-fire',
  //     'animation-iteration-count': 'infinite',
  //     'animation-direction': 'alternate'
  //   },
  //   name: 'Fire'
  // },
  // {
  //   css: {
  //     'background': 'repeating-linear-gradient(45deg, currentColor, currentColor .1em, #ff0a0a .1em, #ff0a0a .15em)',
  //     'background-clip': 'text',
  //     '-webkit-background-clip': 'text',
  //     'text-fill-color': 'transparent',
  //     'animation': '20s linear 0s infinite font-effect-stripes'
  //   },
  //   name: 'Stripes'
  // },
  {
    css: {
      'background': 'url("//cdn.ellacard.com/text-effects/fire_92x64.gif"), linear-gradient(15deg, #F000 0%, #F000 35%, #000 49.95%, #000 50.15%, #F000 65%, #F000), linear-gradient(to right, rgb(200, 51, 24), rgb(158, 51, 24))',
      'background-size': 'auto 1lh',
      'background-repeat': 'repeat',
      'background-clip': 'text',
      '-webkit-background-clip': 'text',
      'text-fill-color': 'transparent',
      'text-stroke': '0.01em #FFF1',
      'text-shadow': '0.01em 0.01em 0 #FFF3'
    },
    combine: {
      'Bold': { 'text-stroke': '.03em #FFF1' }
    },
    name: 'Fire'
  },
  {
    css: {
      'background': 'url("//cdn.ellacard.com/text-effects/water_128x64.gif"), linear-gradient(#88F0 0%, #88F0 35%, #CCC 49.95%, #CCC 50.15%, #88F0 65%, #88F0), linear-gradient(to right, rgb(124, 151, 200), rgb(150, 170, 220))',
      'background-size': 'auto 1lh',
      'background-repeat': 'repeat',
      'background-clip': 'text',
      '-webkit-background-clip': 'text',
      'text-fill-color': 'transparent',
      'text-stroke': '0.01em #FFF1',
      'text-shadow': '0.01em 0.01em 0 #FFF3'
    },
    combine: {
      'Bold': { 'text-stroke': '.03em #FFF1' }
    },
    name: 'Water'
  },
  {
    css: {
      'background': 'url("//cdn.ellacard.com/text-effects/sparkles_128x64.gif"), repeating-linear-gradient(45deg, rgba(124, 151, 200, .5), rgba(227, 227, 227, .5) 20px, rgba(124, 151, 200, .5) 40px), repeating-linear-gradient(-45deg, rgba(124, 151, 200, .5), rgba(227, 227, 227, .5) 20px, rgba(124, 151, 200, .5) 40px)',
      'background-size': 'auto 1lh',
      'background-repeat': 'repeat',
      'background-clip': 'text',
      '-webkit-background-clip': 'text',
      'text-fill-color': 'transparent',
      'text-stroke': '0.01em #FFF1',
      'text-shadow': '0.01em 0.01em 0 #FFF3'
    },
    combine: {
      'Bold': { 'text-stroke': '.03em #FFF1' }
    },
    name: 'Sparkles'
  }
];

export { TEXT_EFFECTS, TEXT_EFFECTS_COMBINE, TEXT_EFFECTS_PRESERVE_KEYS };
